<template>
    <div class="textfieldScreen infoSelectLogin">
        <div class="leftContent">
            <custom-header :img-number="4"></custom-header>
        </div>
        <div class="rightContent" >
            <div class="headBlock">
                <custom-header />
            </div>
            <div class="wrap textfieldScreen_content">
                <h2 v-html="$ml.get('infoSelectLoginTitle')"></h2>
                <div class="radioBlock">
                    <md-radio v-for="(value, key) in list" v-model="contact" :value="key">{{value}}</md-radio>
                </div>
                <p class="errorLine" v-if="errorMessage">{{errorMessage}}</p>
                <div class="grow"></div>
                <p class="helptext" v-html="$ml.get('infoSelectLoginHelpText')">Якщо ви не маєте доступу до
                    запропонованих контактів, зверніться, будь ласка в Центр підтримки клієнтів за телефоном <a href="tel:0800500609" class="tel">0 800 500 609</a></p>
                <slot name="middle"></slot>
                <div class="bottom">
                    <div class="left">
                        <custom-button
                                :button-text="$ml.get('back')"
                                back
                                :action="back"
                        ></custom-button>
                    </div>
                    <div class="right">
                        <custom-button
                                :button-text="$ml.get('next')"
                                success
                                :action="nextScreen"
                                :disabled="isLoading || !contact"
                        ></custom-button>
                    </div>

                </div>
                <div class="bottomLink">
                    <slot name="bottom"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomButton from "../../components/ui/custom-button";
    import CustomHeader from "../../components/ui/custom-header";
    import Profile from "../../helpers/profile";
    import {recoverySendSms as apiRecoverySendSms, getApiErrorMessage} from "../../helpers/api";
    export default {
        name: "selectLoginPage",
        components: {CustomHeader, CustomButton},
        data() {
            return {
                contact: Profile.recoveryMethod || '',
                list: Profile.recoveryContacts || {},
                errorMessage: '',
                errorTimeout: null,
                isLoading: false,
            }
        },
        methods: {
            nextScreen: function () {
                if (this.isLoading)
                    return;
                Profile.setData({
                    recoveryMethod: this.contact,
                    otptype: this.contact.indexOf('Phone') >= 0 ? 'sms' : 'email',
                    otpcode: '',
                });
                this.isLoading = true;
                apiRecoverySendSms().then(() => {
                    this.$router.push({ name: 'AccessRecoverySendCode'});
                }, err => {
                    this.showError(getApiErrorMessage(err, {
                        '401': this.$ml.get('sendCodeErrorWrong')
                    }));
                }).finally(()=>{
                    this.isLoading = false;
                });
            },
            showError: function (message) {
                this.errorMessage = message;
                clearTimeout(this.errorTimeout);
                this.errorTimeout = setTimeout(() => {
                    this.errorMessage = '';
                }, 3000);
            },
            back: function () {
                Profile.setData({ recoveryMethod: '', otptype : ''});
                this.$router.back();
            },
        },

    }
</script>
<style lang="scss">
    .infoSelectLogin {
        .helptext {
            text-align: left;
            font-size: 14px;
            line-height: 1.5;
            a.tel {
                color: #2c3e50;
                white-space: nowrap;
                font-size: 14px;
                line-height: 1.5;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .radioBlock {
        display: flex;
        flex-direction: column;
        align-content: start;
        margin-top: 26px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        .md-radio {
            width: auto;
            margin: 8px 0;
        }
    }
    .textfieldScreen_content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
    }
    .bottom {
        .left {
            width: 40%;
            float: left;
        }
        .right {
            width: 56%;
            float: right;
        }
    }
    .errorLine {
        font-size: 14px;
        color: #e53935;
        text-align: left;
    }
    @media (min-width: 601px) and (max-width: 750px) {
        .textfieldScreen_content {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }
    @media (min-width: 751px) {
        .radioBlock {
            margin-top: 34px;
        }
        .textfieldScreen_content {
            height: calc(100vh - 220px);
            max-height: 700px;
        }
    }
</style>